"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var weapon_1 = __importDefault(require("../items/weapon"));
var craefter_1 = __importDefault(require("./craefter"));
var types_1 = require("../data/types");
var rand_1 = require("../tools/rand");
var mathjs_1 = require("mathjs");
var config_1 = __importDefault(require("../../config"));
var resources_1 = __importDefault(require("../resources"));
var WeaponCraefter = /** @class */ (function (_super) {
    __extends(WeaponCraefter, _super);
    function WeaponCraefter(_a) {
        var _b = _a === void 0 ? {} : _a, 
        // @ts-ignore
        delay = _b.delay, _c = _b.str, str = _c === void 0 ? config_1.default.weaponCraefterInitialStr : _c, _d = _b.int, int = _d === void 0 ? config_1.default.weaponCraefterInitialInt : _d, _e = _b.dex, dex = _e === void 0 ? config_1.default.weaponCraefterInitialDex : _e, _f = _b.luk, luk = _f === void 0 ? config_1.default.weaponCraefterInitialLuk : _f;
        var _this = _super.call(this, {
            type: types_1.CraefterTypes.WeaponCraefter,
            delay: delay,
            str: str,
            int: int,
            dex: dex,
            luk: luk
        }) || this;
        _this.expMax = config_1.default.weaponCraefterInitialRequiredExp;
        return _this;
    }
    WeaponCraefter.hydrate = function (obj) {
        var weaponcraefter = Object.assign(new WeaponCraefter(), obj);
        craefter_1.default.hydrate(weaponcraefter, obj);
        return weaponcraefter;
    };
    WeaponCraefter.prototype.evaluateItemType = function (ratios, highestResource) {
        var type = types_1.Unknown;
        switch (highestResource) {
            case types_1.ResourceTypes.Metal:
                type = types_1.WeaponTypes.Sword;
                if (ratios[types_1.ResourceTypes.Wood] > 0) {
                    type = types_1.WeaponTypes.Knife;
                    if (ratios[types_1.ResourceTypes.Metal] > ratios[types_1.ResourceTypes.Wood] * 2) {
                        type = types_1.WeaponTypes.Sword;
                    }
                }
                break;
            case types_1.ResourceTypes.Wood:
                type = types_1.WeaponTypes.Staff;
                if (ratios[types_1.ResourceTypes.Diamond] > 0) {
                    type = types_1.WeaponTypes.Wand;
                }
                break;
            case types_1.ResourceTypes.Diamond:
                if (ratios[types_1.ResourceTypes.Wood] > 0 &&
                    ratios[types_1.ResourceTypes.Wood] > ratios[types_1.ResourceTypes.Metal] * 2 &&
                    ratios[types_1.ResourceTypes.Diamond] > ratios[types_1.ResourceTypes.Wood] * 2) {
                    type = types_1.WeaponTypes.JewelWand;
                }
                if (ratios[types_1.ResourceTypes.Metal] > 0 &&
                    ratios[types_1.ResourceTypes.Wood] > 0 &&
                    ratios[types_1.ResourceTypes.Diamond] > ratios[types_1.ResourceTypes.Metal] + ratios[types_1.ResourceTypes.Wood]) {
                    type = types_1.WeaponTypes.JewelKnife;
                }
                if (ratios[types_1.ResourceTypes.Metal] > 0 &&
                    ratios[types_1.ResourceTypes.Diamond] > ratios[types_1.ResourceTypes.Metal] * 2) {
                    if (ratios[types_1.ResourceTypes.Metal] > ratios[types_1.ResourceTypes.Wood] * 2) {
                        type = types_1.WeaponTypes.JewelSword;
                    }
                }
                break;
            default:
                break;
        }
        return type;
    };
    WeaponCraefter.prototype.evaluateItem = function (_a) {
        var resources = (_a === void 0 ? {
            resources: new resources_1.default()
        } : _a).resources;
        // 2 percent of all resources is the base
        var baseline = (resources.sum() / 100);
        // add atk mainly based on metal
        // todo add str influence
        var atk = mathjs_1.round(baseline + craefter_1.default.calculateMaterialImpact(resources[types_1.ResourceTypes.Metal])) * this.level;
        // add matk mainly based on wood
        // todo add int influence
        var matk = mathjs_1.round(baseline + craefter_1.default.calculateMaterialImpact(resources[types_1.ResourceTypes.Wood])) * this.level;
        var ratios = resources.ratios();
        var highestResource = ratios.getHighest();
        return {
            category: types_1.ItemCategories.Weapon,
            type: this.evaluateItemType(ratios, highestResource),
            rarity: types_1.Unknown,
            material: highestResource,
            atk: atk,
            // todo: let this be influenced by luk
            atkMax: mathjs_1.round(atk + (atk * mathjs_1.log(2))) || 1,
            matk: matk,
            // todo: let this be influenced by luk
            matkMax: mathjs_1.round(matk + (matk * mathjs_1.log(2))) || 1
        };
    };
    WeaponCraefter.prototype.craeft = function (_a) {
        var resources = (_a === void 0 ? {
            resources: new resources_1.default()
        } : _a).resources;
        _super.prototype.craeft.call(this, {
            resources: resources
        });
        var _b = this.evaluateItem({
            resources: resources
        }), type = _b.type, material = _b.material, atk = _b.atk, atkMax = _b.atkMax, matk = _b.matk, matkMax = _b.matkMax;
        var item = new weapon_1.default({
            type: type,
            material: material,
            resources: resources,
            delay: resources.sum() / this.level,
            level: this.level,
            craefterId: this.id,
            // todo include luk
            atk: rand_1.getRandomInt(atk, atkMax),
            matk: rand_1.getRandomInt(matk, matkMax)
        });
        this.itemId = item.id;
        return item;
    };
    return WeaponCraefter;
}(craefter_1.default));
exports.default = WeaponCraefter;
